import React from 'react';
import crossBtn from "../../assets/img/utils/cross.svg";

const IconCloseButton = (props) => {
    const {closeHandler, styleClass = ""} = props
    return <i className={`fa-solid fa-xmark close-icon-style ${styleClass}`} onClick={closeHandler}></i>
}

export default IconCloseButton;